import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  createTheme,
  useMediaQuery,
} from '@mui/material';
import './style.css';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { enIN } from 'date-fns/locale';
import AuthStore from '../../store/AuthStore';
import LeadStore from '../../store/LeadStore';
import dayjs from 'dayjs';
import LoadingProgressStore from '../../store/LoadingProgressStore';
import CascadingDropdown from './SubPages/CascadingDropdown';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const EditLeadDetails = observer(
  ({ leadDetails, pipeLineId, workflowStatusByPipeLine, priorities, handleEditLeadDetails }) => {
    console.log('🚀 ~ EditLeadDetails ~ leadDetails:', leadDetails);
    const theme = createTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [workflowSubStatusListByWorkflowId, setWorkflowSubStatusListByWorkflowId] = useState([]);

    const [formData, setFormData] = useState({
      id: leadDetails.id,
      name: leadDetails.customerName,
      description: leadDetails.description,
      tags: leadDetails.tags,
      requirement: leadDetails.requirement,
      emailId: leadDetails.emailId,
      currentWorkflowId: leadDetails.currentWorkflowId,
      currentWorkflowSubStatusId: leadDetails.currentWorkflowSubStatusId,
      leadSource: leadDetails.leadSource,
      contactNo: leadDetails.contactNo,
      leadHandledBy: leadDetails.leadHandledBy,
      clientPointOfContact: leadDetails?.clientPointOfContact,
      amount: leadDetails.amount,
      probability: leadDetails.probability,
      actiondDate: new Date(),
      closeDate: leadDetails.closeDate,
      userId: AuthStore.userDetails.Id,
      assignedUserId: AuthStore.userDetails.Id,
      priorityId: leadDetails.priorityId,
      masterLife: leadDetails.masterLife,
      leadSiteDimension: leadDetails.leadSiteDimension,
      constructionStartTimeLine: leadDetails.constructionStartTimeLine,
      projectValue: leadDetails.projectValue,
      projectTimeLine: leadDetails.projectTimeLine,
      builtUpArea: leadDetails.builtUpArea,
      siteAddress: leadDetails.siteAddress,
      contractName: leadDetails.contractName,
    });

    const [errors, setErrors] = useState({
      name: false,
      emailId: false,
      contactNo: false,
      currentWorkflowSubStatusId: false,
    });

    const [errorMessages, setErrorMessages] = useState({
      emailId: '',
      contactNo: '',
    });

    const handleWorkflowStatusChanged = (e) => {
      LoadingProgressStore.toggleIsLoading(true);
      const { value } = e.target;
      handleChange(e);
      LeadStore.getWorkflowSubStatusByWorkflowId(value, pipeLineId);
    };

    console.log('formData', formData);

    useEffect(() => {
      !isEmpty(leadDetails?.currentWorkflowId) &&
        LeadStore.getWorkflowSubStatusByWorkflowId(leadDetails.currentWorkflowId, pipeLineId);
    }, [leadDetails]);

    useEffect(() => {
      workflowSubStatusListByWorkflowId.find((item) => item.id === formData.currentWorkflowSubStatusId) === null &&
        setFormData({ ...formData, currentWorkflowSubStatusId: null });
    }, [formData.currentWorkflowId]);

    useEffect(() => {
      setWorkflowSubStatusListByWorkflowId(LeadStore.workflowSubStatusListByWorkflowId);
      LoadingProgressStore.toggleIsLoading(false);
    }, [LeadStore.workflowSubStatusListByWorkflowId]);

    useEffect(() => {
      LoadingProgressStore.toggleIsLoading(false);
    }, [LeadStore.error]);

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });

      // Perform validation
      if (name === 'emailId') {
        setErrors({ ...errors, [name]: isEmailIdError(value) });
      } else if (name === 'contactNo') {
        setErrors({ ...errors, [name]: isContactNoError(value) });
      } else {
        setErrors({ ...errors, [name]: isEmpty(value) });
      }
    };

    const handleUpdateLeadSubmit = (e) => {
      e.preventDefault();

      const updatedErrors = {
        name: isEmpty(formData.name),
        emailId: isEmailIdError(formData.emailId),
        contactNo: isContactNoError(formData.contactNo),
        currentWorkflowSubStatusId: iscurrentWorkflowSubStatusIdError(),
      };
      setErrors(updatedErrors);

      if (!Object.values(updatedErrors).some((error) => error === true)) {
        LeadStore.updateLead(formData);
      }
    };

    useEffect(() => {
      LeadStore.updateLeadSuccess && handleEditLeadDetails();
    }, [LeadStore.updateLeadSuccess]);

    const isContactNoError = (value) => {
      return false;
      // if (isEmpty(value)) {
      //   return false
      // } else if (!(/^\d{0,10}$/.test(value))) {
      //   setErrorMessages({ ...errors, 'contactNo': 'Please enter valid 10 digit contact number'})
      //   return true
      // } else {
      //   return false
      // }
    };

    const isEmailIdError = (value) => {
      if (isEmpty(value)) {
        setErrorMessages({ ...errors, emailId: '' });
        return false;
      } else if (!value.includes('@')) {
        setErrorMessages({
          ...errors,
          emailId: 'Please enter the valid emailId',
        });
        return true;
      } else {
        setErrorMessages({ ...errors, emailId: '' });
        return false;
      }
    };

    const siteDimentionsList = [
      { id: 1, name: '30 x 40' },
      { id: 2, name: '40 x 60' },
      { id: 3, name: '30 x 50' },
      { id: 4, name: '50 x 80' },
      { id: 5, name: 'Others' },
    ];

    const constructionStartTimeLineList = [
      { id: 1, name: '1-2 Months' },
      { id: 2, name: '3-6 Months' },
      { id: 3, name: 'Immediate' },
      { id: 4, name: 'Others' },
    ];

    const iscurrentWorkflowSubStatusIdError = () => {
      return (
        !isEmpty(formData.currentWorkflowId) &&
        workflowSubStatusListByWorkflowId.length > 0 &&
        isEmpty(formData.currentWorkflowSubStatusId)
      );
    };

    const isEmpty = (value) => {
      return (
        value === null ||
        value === undefined ||
        (!Number.isInteger(value) && !(value instanceof Date) && value?.trim() === '')
      );
    };

    const hierarchyData = {
      label: 'Requirement', // Label for the top level dropdown
      required: false, // Not mandatory
      options: [
        {
          label: 'Construction',
          required: false,
          options: [
            {
              label: 'Residential',
              required: false,
              allowFreeField: true,
              options: [
                { label: 'G', required: false, options: [] },
                { label: 'G + 1', required: false, options: [] },
                { label: 'G + 2', required: false, options: [] },
                { label: 'G + 3', required: false, options: [] },
              ],
            },
            {
              label: 'Commercial',
              required: false,
              options: [
                { label: 'Cellar', required: false, options: [] },
                { label: 'Cellar + Ground', required: false, options: [] },
                { label: 'Cellar + Ground + 1', required: false, options: [] },
                { label: 'Cellar + Ground + 2', required: false, options: [] },
                { label: 'Cellar + Ground + 3', required: false, options: [] },
                { label: 'Ground', required: false, options: [] },
                { label: 'Ground + 1', required: false, options: [] },
                { label: 'Ground + 2', required: false, options: [] },
                { label: 'Ground + 3', required: false, options: [] },
              ],
            },
            {
              label: 'PEB',
              required: false,
              options: [
                {
                  label: 'Vertical Structure',
                  required: false,
                  options: [
                    {
                      label: 'Vertical Structure',
                      required: false,
                      options: [],
                    },
                    { label: 'Cellar + Ground', required: false, options: [] },
                    {
                      label: 'Cellar + Ground + 1',
                      required: false,
                      options: [],
                    },
                    {
                      label: 'Cellar + Ground + 2',
                      required: false,
                      options: [],
                    },
                    {
                      label: 'Cellar + Ground + 3',
                      required: false,
                      options: [],
                    },
                    { label: 'Ground', required: false, options: [] },
                    { label: 'Ground + 1', required: false, options: [] },
                    { label: 'Ground + 2', required: false, options: [] },
                    { label: 'Ground + 3', required: false, options: [] },
                  ],
                },
                {
                  label: 'Horizontal Structure',
                  required: false,
                  allowFreeField: true,
                  options: [
                    { label: 'Units - Sqft / m', required: false, options: [] },
                    { label: 'Width', required: false, options: [] },
                    { label: 'Length', required: false, options: [] },
                  ],
                },
              ],
            },
            {
              label: 'Renovation',
              required: false,
              allowFreeField: true,
              options: [],
            },
          ],
        },
        {
          label: 'Interiors',
          required: false,
          options: [
            {
              label: 'Residential',
              required: false,
              allowFreeField: true,
              options: [
                { label: 'Independent Villa', required: false, options: [] },
                { label: 'Apartment 1 BHK', required: false, options: [] },
                { label: 'Apartment 2 BHK', required: false, options: [] },
                { label: 'Apartment 3 BHK', required: false, options: [] },
                { label: 'Apartment 4 BHK', required: false, options: [] },
              ],
            },
            {
              label: 'Commercial',
              required: false,
              allowFreeField: true,
              options: [
                { label: 'Office Space', required: false, options: [] },
                { label: 'Restobar', required: false, options: [] },
              ],
            },
          ],
        },
        {
          label: 'Consultation',
          required: false,
          options: [
            { label: 'Residential', required: false, options: [] },
            { label: 'Commercial', required: false, options: [] },
            { label: 'Interiors', required: false, options: [] },
          ],
        },
      ],
    };

    const handleSelectionChange = (selectedValues) => {
      console.log('Selected values:', selectedValues);
    };
    return (
      <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
        <Box
          id="lead-details-form"
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={(event) => {
            event.preventDefault();
            handleUpdateLeadSubmit(event);
          }}
        >
          <Stack spacing={4}>
            <Stack spacing={3}>
              <Typography sx={{ fontWeight: '500', alignSelf: 'start' }} component="p">
                Client Information
              </Typography>
              <Grid rowGap={2} container>
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ pr: isSmallScreen ? '0px' : '10px' }}>
                  <Stack direction={'column'} spacing={3}>
                    <TextField
                      label="Name"
                      required
                      id="client-name"
                      size="small"
                      variant="standard"
                      name="name"
                      value={formData.name ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.name)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      id="outlined-emailId"
                      name="emailId"
                      label="EmailId"
                      size="small"
                      variant="standard"
                      value={formData.emailId}
                      onChange={handleChange}
                      error={Boolean(errors.emailId)}
                      helperText={Boolean(errors.emailId) && errorMessages.emailId}
                      fullWidth
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {/* <TextField
                    label='Requirement'
                    id="requirement"
                    size="small"
                    variant="standard"
                    name="requirement"
                    value={formData.requirement ?? ''}
                    onChange={e => handleChange(e)}
                    error={Boolean(errors.requirement)}
                    sx={{fontSize: '12px'}}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  /> */}
                    <CascadingDropdown
                      data={hierarchyData}
                      name={'requirement'}
                      value={formData.requirement ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.requirement)}
                    />

                    <CascadingDropdown
                      data={{
                        label: 'Lead Source',
                        required: false,
                        allowFreeField: true,
                        options: [
                          {
                            label: 'Present Campaign',
                            required: false,
                            options: [],
                          },
                          { label: 'Newspaper', required: false, options: [] },
                          { label: 'Youtube', required: false, options: [] },
                          { label: 'Google ads', required: false, options: [] },
                          { label: 'Website', required: false, options: [] },
                          { label: 'Instagram', required: false, options: [] },
                          { label: 'Facebook', required: false, options: [] },
                          { label: 'Walk-in', required: false, options: [] },
                          {
                            label: 'Employee Referral',
                            required: false,
                            options: [],
                          },
                          {
                            label: 'Channel Partner Referral',
                            required: false,
                            options: [],
                          },
                          {
                            label: 'Client Referral',
                            required: false,
                            options: [],
                          },
                          {
                            label: 'Management Referral',
                            required: false,
                            options: [],
                          },
                        ],
                      }}
                      name="leadSource"
                      value={formData.leadSource ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.leadSource)}
                    />

                    <TextField
                      label="Contact Number"
                      id="contact-number"
                      size="small"
                      variant="standard"
                      name="contactNo"
                      sx={{ fontSize: '12px' }}
                      value={formData.contactNo ?? ''}
                      onChange={handleChange}
                      error={Boolean(errors.contactNo)}
                      helperText={Boolean(errors.contactNo) && errorMessages.contactNo}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      label="Amount"
                      id="amount"
                      size="small"
                      type="number"
                      variant="standard"
                      sx={{ fontSize: '12px' }}
                      name="amount"
                      maxLength="300"
                      value={formData.amount ?? ''}
                      onChange={handleChange}
                      error={Boolean(errors.amount)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      label="Master File"
                      id="master-life"
                      size="small"
                      variant="standard"
                      name="masterLife"
                      multiline
                      rows={1}
                      value={formData.masterLife ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.masterLife)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <FormControl variant="standard" error={Boolean(errors.leadSiteDimension)}>
                      <InputLabel id="leadSiteDimensionLabel" shrink={true}>
                        Site Dimention
                      </InputLabel>
                      <Select
                        labelId="leadSiteDimensionLabel"
                        id="leadSiteDimension"
                        name="leadSiteDimension"
                        value={formData.leadSiteDimension ?? ''}
                        onChange={(e) => {
                          const {
                            target: { value },
                          } = e;
                          setFormData({
                            ...formData,
                            leadSiteDimension: value,
                          });
                          setErrors({
                            ...errors,
                            leadSiteDimension: isEmpty(value),
                          });
                        }}
                        label="Site Dimention"
                        MenuProps={MenuProps}
                      >
                        {siteDimentionsList.map((site) => (
                          <MenuItem key={site.id} value={site.name}>
                            <ListItemText primary={site.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      label="Project Value"
                      id="project-value"
                      size="small"
                      variant="standard"
                      name="projectValue"
                      type="number"
                      value={formData.projectValue ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.projectValue)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      label="Builtup Area"
                      id="builtup-area"
                      size="small"
                      variant="standard"
                      name="builtUpArea"
                      value={formData.builtUpArea ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.builtUpArea)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ pl: isSmallScreen ? '0px' : '10px' }}>
                  <Stack direction={'column'} spacing={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enIN}>
                      <DatePicker
                        label="Closing Date"
                        value={leadDetails.closeDate ? new Date(leadDetails.closeDate) : null}
                        onChange={(newValue) => {
                          handleChange({
                            target: { name: 'closeDate', value: newValue },
                          });
                        }}
                        slotProps={{
                          textField: {
                            size: 'small',
                            variant: 'standard',
                            name: 'closeDate',
                            fontSize: '12px',
                            InputLabelProps: { shrink: true },
                          },
                        }}
                      />
                    </LocalizationProvider>
                    <FormControl variant="standard">
                      <InputLabel id="stage-select-standard-label">Stage</InputLabel>
                      <Select
                        value={formData.currentWorkflowId}
                        onChange={handleWorkflowStatusChanged}
                        size="small"
                        name="currentWorkflowId"
                        displayEmpty
                      >
                        {workflowStatusByPipeLine.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl
                      variant="standard"
                      required={workflowSubStatusListByWorkflowId.length > 0}
                      error={Boolean(errors.currentWorkflowSubStatusId)}
                      sx={{
                        display: `${workflowSubStatusListByWorkflowId.length > 0 ? '' : 'lm-d-none'}`,
                      }}
                    >
                      <InputLabel id="sub-stage-select-standard-label" shrink={true}>
                        Sub Stage
                      </InputLabel>
                      <Select
                        value={formData.currentWorkflowSubStatusId ?? ''}
                        onChange={handleChange}
                        size="small"
                        name="currentWorkflowSubStatusId"
                        displayEmpty
                      >
                        {workflowSubStatusListByWorkflowId.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl variant="standard">
                      <InputLabel id="priority-select-standard-label">Priority</InputLabel>
                      <Select
                        value={formData.priorityId}
                        onChange={handleChange}
                        size="small"
                        name="priorityId"
                        displayEmpty
                      >
                        {priorities.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <TextField
                      label="Probability for signup"
                      id="probablity"
                      size="small"
                      variant="standard"
                      type="number"
                      sx={{ fontSize: '12px' }}
                      name="probability"
                      value={formData.probability ?? ''}
                      onChange={handleChange}
                      error={Boolean(errors.probability)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <CascadingDropdown
                      data={{
                        label: 'Lead Handled by',
                        required: false,
                        options: [
                          {
                            label: 'Sales Partner',
                            required: false,
                            allowFreeField: true,
                            options: [{ label: '', required: false, options: [] }],
                          },
                          {
                            label: 'Designers',
                            required: false,
                            allowFreeField: true,
                            options: [{ label: '', required: false, options: [] }],
                          },
                          {
                            label: 'Project Manager',
                            required: false,
                            allowFreeField: true,
                            options: [{ label: '', required: false, options: [] }],
                          },
                          {
                            label: 'Site Engineer',
                            required: false,
                            allowFreeField: true,
                            options: [{ label: '', required: false, options: [] }],
                          },
                          {
                            label: 'Interior Designer',
                            required: false,
                            allowFreeField: true,
                            options: [{ label: '', required: false, options: [] }],
                          },
                          {
                            label: 'Name',
                            required: false,
                            allowFreeField: true,
                            options: [{ label: '', required: false, options: [] }],
                          },
                        ],
                      }}
                      name="leadHandledBy"
                      value={
                        formData.leadHandledBy
                          ? formData.leadHandledBy.includes(',')
                            ? formData.leadHandledBy
                            : `Name, ${formData.leadHandledBy}`
                          : ''
                      }
                      onChange={handleChange}
                      error={Boolean(errors.leadHandledBy)}
                    />

                    <TextField
                      label="Client Point of Contact"
                      required
                      id="clientPointOfContact"
                      size="small"
                      variant="standard"
                      name="clientPointOfContact"
                      value={formData.clientPointOfContact ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.clientPointOfContact)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />

                    <TextField
                      label="Site Address"
                      id="site-address"
                      size="small"
                      variant="standard"
                      name="siteAddress"
                      multiline
                      rows={1}
                      value={formData.siteAddress ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.siteAddress)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <FormControl variant="standard" error={Boolean(errors.constructionStartTimeLine)}>
                      <InputLabel id="constructionStartTimeLineLabel" shrink={true}>
                        Construction Start TimeLine
                      </InputLabel>
                      <Select
                        labelId="constructionStartTimeLineLabel"
                        id="constructionStartTimeLine"
                        name="constructionStartTimeLine"
                        value={formData.constructionStartTimeLine ?? ''}
                        onChange={(e) => {
                          const {
                            target: { value },
                          } = e;
                          setFormData({
                            ...formData,
                            constructionStartTimeLine: value,
                          });
                          setErrors({
                            ...errors,
                            constructionStartTimeLine: isEmpty(value),
                          });
                        }}
                        label="Construction Start TimeLine"
                        MenuProps={MenuProps}
                      >
                        {constructionStartTimeLineList.map((site) => (
                          <MenuItem key={site.id} value={site.name}>
                            <ListItemText primary={site.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      label="Project Timeline"
                      id="project-timeline"
                      size="small"
                      variant="standard"
                      name="projectTimeLine"
                      value={formData.projectTimeLine ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.projectTimeLine)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <TextField
                      label="Contract Name"
                      id="contract-name"
                      size="small"
                      variant="standard"
                      maxLength="300"
                      name="contractName"
                      value={formData.contractName ?? ''}
                      onChange={(e) => handleChange(e)}
                      error={Boolean(errors.contractName)}
                      sx={{ fontSize: '12px' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
            <Stack spacing={3}>
              <Typography sx={{ fontWeight: '500', alignSelf: 'start' }} component="p">
                Description information
              </Typography>
              <Grid rowGap={2} container>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ pr: isSmallScreen ? '0px' : '10px' }}>
                  <Stack direction={'column'} spacing={2}>
                    <TextField
                      label="Description If any"
                      id="description-if-any"
                      size="small"
                      variant="standard"
                      multiline
                      maxRows={4}
                      sx={{ fontSize: '12px' }}
                      name="description"
                      value={formData.description ?? ''}
                      onChange={handleChange}
                      error={Boolean(errors.description)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ pr: isSmallScreen ? '0px' : '10px' }}>
                  <Stack direction={'column'} spacing={2}>
                    <TextField
                      label="Tags"
                      id="tags"
                      size="small"
                      variant="standard"
                      sx={{ fontSize: '12px' }}
                      name="tags"
                      value={formData.tags ?? ''}
                      onChange={handleChange}
                      error={Boolean(errors.tags)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 20 }}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
            <Stack direction={'row'} sx={{ ml: 'auto' }} alignSelf={isSmallScreen ? '' : 'end'} spacing={2}>
              <Button
                variant="outlined"
                color="inherit"
                fullWidth
                size="small"
                onClick={() => handleEditLeadDetails(false)}
              >
                Cancel
              </Button>
              <Button variant="contained" type="submit" fullWidth color="primary" size="small">
                Update
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Paper>
    );
  }
);
